export enum AccountType {
  client = 'client',
  acquisition = 'acquisition',
  prospect = 'prospect',
  test = 'test',
}

export enum AccountTypeLabel {
  client = 'Client',
  acquisition = 'Acquisition',
  prospect = 'Prospect',
  test = 'Test',
}
